var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./MealTagTableTemp.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-19b30bd7\"}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./MealTagTableTemp.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/views/Platform/Temp/MealTagTableTemp.vue
// module id = 2245
// module chunks = 1